import React from "react";
import "./discord.css";

const Discord = () => {
    return <>
    <a className="link-d" href="https://discord.gg/legendsofshangu" target="_blank">
      <div className="discord">
          <h2>
              Join us <br />
              on Discord ! <br/>
              
                <i class="fab fa-discord"></i>
              
          </h2>
      </div>
      </a>
    </>
};

export default Discord;
